<template>
  <el-card>
    <template slot="header">
      <div class="header-flex">
        <span>Notificar parada vacía</span>
        <workgroup-central-selector
          v-model="centralAndWorkgroup"
          :allow-select-workgroups="false"
          @input="loadStops()"
        />
      </div>
    </template>
    <el-form label-position="top" size="mini">
      <el-form-item label="Parada" :class="formItemErrorClass($v.formData.stop)">
        <el-select v-model="formData.stop" filterable>
          <el-option
            v-for="stop in flattenStops"
            :key="stop.id"
            :value="stop.id"
            :label="stop.name"
            >{{ stop.name }}</el-option
          >
        </el-select>
        <ErrorMessage :data="$v.formData.stop" validation="required" />
      </el-form-item>
      <el-form-item label="Clientes esperando">
        <el-radio-group v-model="formData.peopleWaiting">
          <el-radio-button :label="0">Sin clientes</el-radio-button>
          <el-radio-button :label="1">1</el-radio-button>
          <el-radio-button :label="2">2</el-radio-button>
          <el-radio-button :label="3">3</el-radio-button>
          <el-radio-button :label="4">4</el-radio-button>
          <el-radio-button :label="5">5</el-radio-button>
          <el-radio-button :label="10">10</el-radio-button>
          <el-radio-button :label="15">15</el-radio-button>
          <el-radio-button :label="20">20</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-button type="primary" class="mt-2" @click="sendMessage"
        ><i class="fas fa-fw fa-paper-plane pr-2"></i> Notificar</el-button
      >
    </el-form>
  </el-card>
</template>

<script>
import ErrorMessage from "@/components/common/forms/ErrorMessage";
import WorkgroupCentralSelector from "@/components/common/forms/WorkgroupCentralSelector";
import errors from "@/mixins/errors";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CardEmptyStopMessage",
  components: {
    WorkgroupCentralSelector,
    ErrorMessage,
  },
  mixins: [errors],

  data() {
    return {
      centralAndWorkgroup: [],
      formData: {
        stop: null,
        peopleWaiting: 0,
      },
    };
  },
  validations: {
    formData: {
      stop: {
        required,
      },
    },
  },
  created() {
    this.centralAndWorkgroup = this.defaultSelectedWorkgroupAndCentral;
    this.loadStops();
  },
  computed: {
    ...mapGetters("app", ["defaultSelectedWorkgroupAndCentral"]),
    ...mapGetters("clientStops", ["stops"]),
    flattenStops() {
      return this.stops?.flat() || [];
    },
  },
  methods: {
    ...mapActions("clientStops", ["getStops"]),
    ...mapActions("clientMessages", ["createMessage"]),
    loadStops() {
      this.getStops(this.centralAndWorkgroup.map((a) => a.wgId));
    },
    async sendMessage() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const stopName = this.flattenStops.find((stop) => stop.id === this.formData.stop).name;
        const people = this.formData.peopleWaiting;
        let message =
          `La central notifica que hay ${people} clientes esperando en ${stopName}`.toUpperCase();
        if (people === 0) {
          message =
            `La central notifica que ya no hay clientes esperando en ${stopName}`.toUpperCase();
        }
        const payload = {
          data: null,
          params: {
            target: 2, // Flota
            param: JSON.stringify({
              wgId: this.centralAndWorkgroup[0]?.wgId,
              centralId: this.centralAndWorkgroup[0]?.centralId,
            }),
            type: 2, // Aviso
            body: JSON.stringify({ text: message }),
          },
        };
        await this.createMessage(payload);
        this.$message.success("Aviso enviado a toda la flota.");
      }
    },
  },
};
</script>

<style>
.header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
